import {
  commissionFields,
  commissionLayoutRow,
} from '../../shared/cards/commissionFields';
import { personalDealField } from '../../shared/cards/complianceUpstreamFields';
import type { CoverSheetConfigCard } from '../../types';

export const commissionDetailsCard = {
  id: 'propertyInfo.commissionDetails',
  innerTitle: 'Commission Details',
  layout: [
    commissionLayoutRow('commission'),
    [{ name: 'isPersonalDeal', size: 25, mobileSize: 50 }],
  ],
  fields: {
    ...commissionFields('commission', {
      label: 'Buyer’s Agent Compensation',
      additionalLabel: 'Additional Buyer’s Agent Compensation',
      required: false,
    }),
    isPersonalDeal: personalDealField,
  },
} satisfies CoverSheetConfigCard;
